<template>
	<div class="program">
		<div class="program-main" v-if="!app.loading">
			<div class="program-content" @click="expand_program(operation[0])">
				<div class="image" v-if="t_photo.length">			
					<ImagePreview :src="operation[0].url_photo" width="112" height="90" @error="handleImageError" v-if="t_photo.length < 2"/>
					<Galleria v-else :value="t_photo" :numVisible="5" containerStyle="max-width: 112px; height:90px" :showThumbnails="false" :showIndicators="true" :showIndicatorsOnItem="true" :circular="true" :autoPlay="true" :transitionInterval="4000">
						<template #item="slotProps">
							<img :src="slotProps.item" style="width: 100%; display: block" />
						</template>
					</Galleria>
				</div>
                <div class="program-info" :class="{sansphoto: !t_photo.length}">
                    <div class="program-title" :class="{sansphoto: !t_photo.length, redveb: fullveb}">{{operation[0].nom_operation}}</div>
                    <div class="program-details">
                        <span style="font-weight: 500; color: rgb(108, 92, 231);" :class="{redveb: fullveb}">{{ operation[0].codepostal }}</span> {{ operation[0].ville }}
                        <div class="promoteur">{{ operation[0].promoteur }}</div>
                    </div>
					<div style="display: flex;justify-content: space-between;">
                        <div class="tranche-tags">
                            <!--<div class="vebacte sp" v-if="veb">{{ $t('VEB') }}</div>-->
                            <span class="badge badge-orange" v-if="veb">VEB</span>
                        </div>
                        <div class="program-price" v-if="!fullveb">
                            {{ getPrice()[0] }} - {{ getPrice()[1] }}/m²
                        </div>
                    </div>
					<div style="display: flex;justify-content: flex-end;padding-right: 5px;"  v-if="fullveb">
						<div class="veb-badge">
							<!--
							<svg class="veb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
							</svg>
							-->
							<span>100%</span>VEB
						</div>

					</div>
                </div>


            </div>
                <div class="cz" v-if="!app.loading">

                    <label class="checkbox" :class="{ checked: checked }">
                        <input type="checkbox" :checked="checked" @click="select_program(operation)" />
                        <span class="chk"><icon file="check" :size="16" /></span>
                        <span class="text"></span>
                    </label>
                </div>
			<div class="tranches-label" v-if="!fullveb">{{ operation.length }} tranches disponibles en vente au détail :</div>
			<div class="tranches-label" v-else>{{ operation.length }} tranches disponibles en vente en bloc :</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ImagePreview from 'primevue/imagepreview';
// eslint-disable-next-line
import Skeleton from 'primevue/skeleton';
import Galleria from 'primevue/galleria';

export default {
	name: 'Operation',

	data: function PaneProgram() {
		return {
            checked: false,
			expanded: false,
			filter: 'volume',
			filter2: 'typologie',
			defaultImageUrl: 'https://www.myadequation.fr/EFOCUS./no-camera2.png'
		}
	},

	props: [ 'operation' ],

	computed: Object.assign(mapGetters([ 'app', 'expanded_program', 'selected_secteurs' ]), {
		t_photo: function() {
			let t = [];
			for (let index = 0; index < this.operation.length; index++) {
				const element = this.operation[index];
				if (element.url_photo && element.url_photo != null && element.url_photo != "0" && element.url_photo != "-" && t.indexOf(element.url_photo) < 0) {
					t.push(element.url_photo)
				}
			}
			return t;
		},

		fullveb: function() {
			let v = true;
			for (let index = 0; index < this.operation.length; index++) {
				const element = this.operation[index];
				if (!element.veb) {
					return false
				}
			}
			return v;
		},
		veb: function() {
			let v = false;
			for (let index = 0; index < this.operation.length; index++) {
				const element = this.operation[index];
				if (element.liste_veb && element.liste_veb.length ) {
					return true
				}
			}
			return v;
		}
	}),

	methods: {
		handleImageError(event) {
			event.target.src = this.defaultImageUrl; // Remplacer par une image par défaut en cas d'erreur
		},
		getPrice: function() {
			let min = 0
			let max = 0
			for (let index = 0; index < this.operation.length; index++) {
				const element = this.operation[index];
				let nPrice=0
				let sEtat = 'Prix_Stock_'
				let sTva = 'TVAP_LIBRE_'
				let sPk = 'APK'
				nPrice = element[sEtat + sTva + sPk]
				
				if (nPrice <= 0)
				{
					if (this.operation[index].tva_reduite_prix_m2_parking_avec > 0) {
						nPrice = this.operation[index].tva_reduite_prix_m2_parking_avec
					} else {
						if (this.operation[index].tva_reduite_prix_m2_parking_sans > 0) {
							nPrice = this.operation[index].tva_reduite_prix_m2_parking_sans
						} else {
							if (this.operation[index].tva_pleine_libre_prix_m2_parking_avec > 0) {
								nPrice = this.operation[index].tva_pleine_libre_prix_m2_parking_avec
							} else {
								if (this.operation[index].tva_pleine_libre_prix_m2_parking_sans > 0) {
									nPrice = this.operation[index].tva_pleine_libre_prix_m2_parking_sans
								} else {
									if (this.operation[index].tva_pleine_aide_prix_m2_parking_avec > 0) {
										nPrice = this.operation[index].tva_pleine_aide_prix_m2_parking_avec
									} else {
										if (this.operation[index].tva_pleine_aide_prix_m2_parking_sans > 0) {
											nPrice = this.operation[index].tva_pleine_aide_prix_m2_parking_sans
										}
									}
								}
							}
						}
					}
				}
				if (min > nPrice || min == 0) min = nPrice
				if (max < nPrice) max = nPrice
			}
			const euro = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0
            });
			let sMin = ''
			let sMax = ''
			if (min>0) {
                sMin = euro.format(Math.round(min/10)*10)
			}
			if (max>0) {
                sMax = euro.format(Math.round(max/10)*10)
			}
			return[sMin, sMax]
		},

		expand_program: function(program) {
			if (this.expanded_program != program) {
				this.$store.dispatch('expand_program', { program: program })
				this.$router.push({ name: 'program', params: { id: program.id }}).catch(()=>{});
			} else {
				this.$store.dispatch('expand_program', { program: false })
				this.$router.push({ name: 'neuf'}).catch(()=>{});
			}
		},

		select_program: function(o) {
			this.checked = !this.checked
            for (let index = 0; index < o.length; index++) {
                let id = o[index].id + "-" + o[index].ville
                if (this.checked) {
                    if (document.getElementById(id).className.includes('checked')) {
                        //
                    } else {
                        document.getElementById(id).className = 'checkbox checked'
                        this.$store.dispatch('inc_nbprogselect', {})
                    }
                } else {
                    if (document.getElementById(id).className.includes('checked')) {
                        document.getElementById(id).className = 'checkbox'
                        this.$store.dispatch('dec_nbprogselect', {})
                    } else {
                        //
                    }
                }
                for (let i in this.app.programs) {
                    if ((this.app.programs[i].id + "-" + this.app.programs[i].ville)==id) {
                        if (this.app.programs[i].marker) {
                            if (this.checked) {
                                this.app.programs[i].marker.classList.add('selected')
                                this.app.programs[i].marker.classList.remove('invisible')
                            } else {
                                this.app.programs[i].marker.classList.remove('selected')
                                if (this.app.uniquementselection) this.app.programs[i].marker.classList.add('invisible')
                            }
                        }
                    }
                }
            }


		},

		show_program_on_map: function() {
			this.$store.dispatch('center_map', { coords: { lat: this.program.location.lat, lng: this.program.location.lon }, zoom: 16 })
		},

		print: function() {
			this.$store.dispatch('set_print', { print: 'expanded-program' })
		}
	},
	
// eslint-disable-next-line
	components: { ImagePreview, Skeleton, Galleria }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'

        :root {
            --primary: #6c5ce7;
            --primary-light: #a29bfe;
            --primary-dark: #5341d6;
            --secondary: #f1f3f5;
            --secondary-dark: #e9ecef;
            --text-dark: #343a40;
            --text-medium: #6c757d;
            --text-light: #adb5bd;
            --success: #27ae60;
            --warning: #f39c12;
            --white: #ffffff;
            --border-radius: 10px;
            --shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
            --accent-blue: #3498db;
            --accent-orange: #f39c12;
        }
        
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        body {
            background-color: #f8f9fa;
            color: var(--text-dark);
            line-height: 1.6;
            padding: 20px;
        }
        
        .container {
            max-width: 400px;
            margin: 0 auto;
            background-color: white;
            border-radius: var(--border-radius);
            box-shadow: var(--shadow);
            overflow: hidden;
        }
        
        /* Programme principal */
        .program-item {
            padding: 16px;
            border-bottom: 1px solid var(--secondary);
            position: relative;
        }
        
        .program-item:last-child {
            border-bottom: none;
        }
        
        .program-item.has-tranches {
            border-left: 4px solid var(--primary);
        }
        
        .program-content {
            display: flex;
            gap: 12px;
			margin-bottom: 12px;
			padding-bottom: 12px;
			border-bottom: 1px solid #e9ecef;
        }
        
        .program-image {
            width: 80px;
            height: 60px;
            border-radius: 6px;
            object-fit: cover;
            flex-shrink: 0;
        }
        
        .program-info {
            flex: 1;
            min-width: 0;
        }
        
        .program-title {
            margin-bottom: 2px;
            color: #333 !important;
            font-weight: 700;
            height: 24px;
            font-size: 0.9rem;
            line-height: 24px;
            white-space: nowrap;
            width: 200px;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .program-title.sansphoto {
            width: 315px;
        }
        
        .program-details {
            font-size: 12px;
            color: var(--text-medium);
            margin-bottom: 4px;
            line-height: 1.3;
        }
        
        .program-badges {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            margin-bottom: 8px;
        }
        
        .badge {
            padding: 2px 6px;
            border-radius: 3px;
            font-size: 10px;
            font-weight: 500;
        }
        
        .badge-veb {
            background-color: #e7f3ff;
            color: var(--accent-blue);
        }
        
        .badge-brs {
            background-color: #fff3e0;
            color: var(--accent-orange);
        }
        
        .badge-tva {
            background-color: #ebfbf0;
            color: var(--success);
        }
        
        .program-price {
            font-size: 0.9rem;
            font-weight: 700;
            color: var(--text-dark);
            text-align: right;
            padding-right: 4px;
        }
        
        .price-unit {
            font-size: 12px;
            font-weight: normal;
            color: var(--text-medium);
        }
        
        /* Checkbox principal */
        .main-checkbox {
            position: absolute;
            top: 16px;
            right: 16px;
            width: 20px;
            height: 20px;
        }
        
        .checkbox-input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }
        
        .checkbox-custom {
            position: absolute;
            top: 0;
            left: 0;
            height: 20px;
            width: 20px;
            background-color: white;
            border: 2px solid var(--text-light);
            border-radius: 3px;
            transition: all 0.2s ease;
            cursor: pointer;
        }
        
        .checkbox-input:checked ~ .checkbox-custom {
            background-color: var(--primary);
            border-color: var(--primary);
        }
        
        .checkbox-custom::after {
            content: "";
            position: absolute;
            display: none;
            left: 6px;
            top: 2px;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
        }
        
        .checkbox-input:checked ~ .checkbox-custom::after {
            display: block;
        }
        
        /* Tranches liées */
        .tranches-container {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px solid var(--secondary);
        }
        
        .tranches-label {
            font-size: 11px;
            color: var(--text-medium);
            margin-bottom: 8px;
            font-weight: 500;
        }
        
        .tranches-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        
        .tranche-row {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px 8px;
            background-color: #f8f9ff;
            border-radius: 4px;
            border: 1px solid transparent;
            transition: all 0.2s ease;
        }
        
        .tranche-row:hover {
            border-color: var(--primary-light);
            background-color: #f0ebff;
        }
        
        .tranche-row.selected {
            border-color: var(--primary);
            background-color: #f0ebff;
        }
        
        .tranche-checkbox {
            width: 16px;
            height: 16px;
            position: relative;
            flex-shrink: 0;
        }
        
        .tranche-checkbox .checkbox-custom {
            width: 16px;
            height: 16px;
        }
        
        .tranche-checkbox .checkbox-custom::after {
            left: 4px;
            top: 1px;
            width: 4px;
            height: 8px;
        }
        
        .tranche-info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 2px;
        }
        
        .tranche-header {
            display: flex;
            align-items: center;
            gap: 6px;
        }
        
        .tranche-name {
            font-size: 12px;
            font-weight: 500;
            color: var(--text-dark);
        }
        
        .type-icon {
            width: 14px;
            height: 14px;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            color: white;
            font-weight: 600;
            flex-shrink: 0;
        }
        
        .type-icon.collectif {
            background-color: var(--primary);
        }
        
        .type-icon.individuel {
            background-color: var(--success);
        }
        
        .tranche-address {
            font-size: 10px;
            color: var(--text-medium);
            line-height: 1.2;
        }
        
        .tranche-tags {
            display: flex;
            gap: 4px;
            margin-right: 8px;
        }
        
        .tranche-tag {
            padding: 1px 4px;
            border-radius: 2px;
            font-size: 9px;
            font-weight: 500;
        }
        
        .tag-veb {
            background-color: #e7f3ff;
            color: var(--accent-blue);
        }
        
        .tag-brs {
            background-color: #fff3e0;
            color: var(--accent-orange);
        }
        
        .tag-tva {
            background-color: #ebfbf0;
            color: var(--success);
        }
        
        .tranche-price {
            font-size: 12px;
            font-weight: 600;
            color: var(--text-dark);
            flex-shrink: 0;
        }
        
.tranches-label {
    font-size: 11px;
    color: var(--text-medium);
    margin-bottom: 8px;
    font-weight: 500;
}    

.cz
	position absolute
	right 4px !important
	top 6px !important

.image
	height 90px
	width 112px
	border-radius 12px
	overflow hidden
	//background #eee url(../../assets/img/no-camera.png) center center no-repeat
	background-size 48px 48px
	img
		position absolute
		left 50%
		transform translateX(-50%)
		height 100%
		width auto

:deep(.p-galleria .p-galleria-indicators) {
    padding: 0.1rem;
}
:deep(.p-galleria .p-galleria-indicators .p-galleria-indicator button) {
    width: 0.5rem;
    height: 0.5rem;
}
:deep(.p-galleria-item-container) {
    height: 90px;
}
.sp
	padding 5px 6px
	font-family Montserrat, sans-serif
	font-style normal
	font-weight normal
	font-size 10px
	line-height 10px
	color: var(--primary-color-text);
	margin-right 2px
	//height 20px
	//left 0
	//bottom 10px
	background #3b82f6
	box-sizing border-box
	border-radius 20px
.vebacte
	background #fd943a !important

.veb-badge {
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    color: white;
    padding: 4px 8px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    box-shadow: 0 2px 8px rgba(231, 76, 60, 0.3);
    display: flex;
    align-items: center;
    gap: 6px;
}

.veb-icon {
    width: 16px;
    height: 16px;
}

.sansphoto {
	padding-left:5px;
}



.badge {
	padding: 3px 8px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
	display: inline-block;
}

.badge-blue {
	background-color: #e7f3ff;
	color: #3498db;
}

.badge-orange {
	background-color: #fff3e0;
	color: #f39c12;
}

.redveb {
    color: #c0392b !important;
}

.promoteur {
    color: #333 !important;
    margin: 8px 0 0 0;
    text-transform: uppercase;
    font-size: 12px;
    width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
}
.promoteur.sansphoto {
    width: 315px;
}
</style>
